import {useStore} from "@nanostores/react";
import {type FC, lazy, Suspense, useEffect} from "react";
import {loadSession, ReadyAtom, SessionAtom} from "./store/session.mjs";

const Fallback = (
    <dialog open>
        <article className="box">
            <h3>{"Секунду"}</h3>
            <p>
                <span aria-busy="true">{"Проверяем сессию..."}</span>
            </p>
        </article>
    </dialog>
);

const Authorize = lazy(() => import("./authorization/Authorize"));
const Application = lazy(() => import("./app/Application"));

export const Bootstrap: FC = () => {
    const session = useStore(SessionAtom);
    const ready = useStore(ReadyAtom);

    useEffect(() => {
        void loadSession();
    }, []);

    if (!ready) {
        return Fallback;
    }

    return <Suspense fallback={Fallback}>{session ? <Application /> : <Authorize />}</Suspense>;
};
